module.exports = __webpack_public_path__ + "static/media/beerbot.a9031931.jpg";